import { render, staticRenderFns } from "./ModalReporteEmpleadosBaja.vue?vue&type=template&id=5858b6bc&scoped=true"
import script from "./ModalReporteEmpleadosBaja.vue?vue&type=script&lang=js"
export * from "./ModalReporteEmpleadosBaja.vue?vue&type=script&lang=js"
import style0 from "./ModalReporteEmpleadosBaja.vue?vue&type=style&index=0&id=5858b6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858b6bc",
  null
  
)

export default component.exports